var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgVisa = function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#172B85",
    fillRule: "evenodd",
    d: "M12.479 15.875h-4.24L5.058 3.463c-.152-.57-.472-1.076-.944-1.314C2.94 1.552 1.643 1.076.228.836V.358H7.06c.943 0 1.65.718 1.768 1.551l1.65 8.954L14.715.358h4.123zm8.717 0H17.19L20.489.358h4.005zm8.48-11.218c.117-.836.824-1.314 1.65-1.314 1.295-.12 2.708.12 3.886.716L35.92.718A9.9 9.9 0 0 0 32.268 0c-3.887 0-6.716 2.15-6.716 5.133 0 2.269 2.004 3.46 3.418 4.178 1.53.716 2.12 1.194 2.002 1.91 0 1.073-1.179 1.551-2.356 1.551-1.414 0-2.828-.358-4.122-.955l-.707 3.343c1.414.595 2.944.835 4.358.835 4.359.118 7.067-2.029 7.067-5.252 0-4.059-5.537-4.297-5.537-6.086m19.552 11.218L46.048.358h-3.415c-.707 0-1.415.478-1.65 1.194l-5.889 14.323h4.123l.823-2.267h5.066l.471 2.267zM43.222 4.537l1.176 5.848h-3.297z",
    clipRule: "evenodd"
  })));
};
var Memo = /*#__PURE__*/memo(SvgVisa);
export default Memo;